import React, { useState } from 'react';
import {
  Modal,
  PrescriptionUI
} from 'medication_service_ui';

const PrescriptionModal = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const activateModal = () => {
    setModalOpen(true);
  }
  const deactivateModal = () => {
    setModalOpen(false);
  }

  const modal = modalOpen && (
    <Modal
      show={modalOpen}
      onClose={deactivateModal}
    >
      <PrescriptionUI
        onComplete={deactivateModal}
        postConsult
        saveQuickRxAvailable={false}
      />
    </Modal>
  );

  return (
    <div>
      <div className="prescription-modal">
        <a
          href="#"
          className="add erx_enabled"
          title="Add Prescription"
          onClick={activateModal}
        >
          Add Prescription
        </a>
        { modal }
      </div>
    </div>
  );
}

PrescriptionModal.propTypes = {};

export default PrescriptionModal;
